import Vue from 'vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import VueCookie from 'vue-cookie'
Vue.use(VueCookie)

import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import { SET_HEADERS, SET_TOKEN } from './store'
import router from './router'

import {eventBus} from './bus'
Vue.prototype.$events = eventBus

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'development') {
  // axios.defaults.baseURL = 'https://127.0.0.1:8000/api'
  axios.defaults.baseURL = 'https://api.rating.ksu.edu.kz'
} else {
  axios.defaults.baseURL = 'https://api.rating.ksu.edu.kz'
}

axios.interceptors.request.use((config) => {
  if (store.getters.isUserLoggedIn) {
    config.headers.common['X-AUTH-TOKEN'] = store.state.token
  }
  return config
})
axios.interceptors.response.use((response) => {
  const token = response.headers['x-auth-token']
  if (token) {
    store.commit(SET_TOKEN, token)
    Vue.prototype.$cookie.set('x-auth-token', token, {expires: '15m'})
    Vue.prototype.$cookie.set('x-user-id', store.state.user?.id, {expires: '15m'})
  }

  store.commit(SET_HEADERS, response.headers)

  return response.data
}, (error) => {
  if ([401, 403].some((code) => {
    return error.response.status === code
  })) {
    store.dispatch('signOut')
    Vue.prototype.$cookie.delete('x-auth-token')
    Vue.prototype.$cookie.delete('x-user-id')
    router.push({name: 'home'})
    return {success: true}
  }
  return Promise.reject(error)
})

import VueI18n from 'vue-i18n'
import ru from './locales/ru'
import kz from './locales/kz'
const messages = {
  ru,
  kz
}
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages
})

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
